// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","818":"auth"}[chunkId] + "." + {"443":"08b5ccc3","818":"c794b048"}[chunkId] + ".css";
};